// import { HttpClient, HttpClientModule } from '@angular/common/http';

// import {
//   FacebookLoginProvider,
//   GoogleLoginProvider
// } from 'angularx-social-login';
// import { SocialAuthServiceConfig } from 'angularx-social-login';

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule } from '@abacritt/angularx-social-login';

import { AppHomeComponent } from './app-home/app-home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './login/login.component';
import { MultiAccountComponent } from './multi-account/multi-account.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerModule } from "ngx-spinner";
import { RegistrationComponent } from './registration/registration.component';
import { SecurityComponent } from './security.component';
import { SubscriptionComponent } from './subscription/subscription.component';

// import { HttpModule } from '@angular/http';



// import { NgxSpinnerModule } from 'ngx-spinner';
// export function getAuthServiceConfigs() {
//   let config = new AuthServiceConfig(
//       [
//         {
//           id: FacebookLoginProvider.PROVIDER_ID,
//           provider: new FacebookLoginProvider("Your-Facebook-app-id")
//         },
//         {
//           id: GoogleLoginProvider.PROVIDER_ID,
//           provider: new GoogleLoginProvider("317079145994-njhoq3f8dgj2kjj5jjr1m4ksts5if9g8.apps.googleusercontent.com")
//         }
         
//       ]);
//   ;
//   return config;
// }


@NgModule({
  declarations: [SecurityComponent, LoginComponent, MultiAccountComponent,RegistrationComponent, AppHomeComponent, SubscriptionComponent],
  imports: [
    FormsModule,
    HttpClientModule,
    BrowserModule,
    CommonModule,
    // SocialLoginModule,
    BrowserAnimationsModule,
    NgSelectModule,
    NgxSpinnerModule,
    SocialLoginModule,
  
  ],
  providers: [
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '317079145994-njhoq3f8dgj2kjj5jjr1m4ksts5if9g8.apps.googleusercontent.com'
            )
          },
      
        ],
        onError: (err) => {
          console.error(err);
        }
      } as SocialAuthServiceConfig,
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  // providers: [
   
    
  //   {
  //     provide: AuthServiceConfig,
  //     useFactory: getAuthServiceConfigs
  //   }
  // ],
  
  exports: [SecurityComponent, LoginComponent,MultiAccountComponent,RegistrationComponent,AppHomeComponent, SubscriptionComponent],
})
export class SecurityModule {}
